import type { IPost } from "../../../../types/models/post.models.types";
import { usePutHttp } from "../../http.hook";

interface IResponse {
  post: IPost;
}

interface IBody {
  message: string;
}

export function useFlagPostAdminHttp() {
  return usePutHttp<IBody, IResponse>({
    path: "/admin/posts/:id/flag",
  });
}
